var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ajaxDone
    ? _c(
        "div",
        { ref: "searchedFaqScrollBox", staticClass: "searched-faq-list" },
        [
          _c("h1", {
            staticClass: "search-key",
            domProps: { textContent: _vm._s(_vm.$route.query.searchKey) }
          }),
          _vm._v(" "),
          _vm._l(_vm.AllFaqList, function(faq, index) {
            return _c(
              "section",
              {
                staticClass: "faq-list box_search",
                class: _vm.$style["box_search"],
                on: {
                  click: function($event) {
                    return _vm.viewFAQ(faq.KBInfoId, index)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "search-item-title",
                  domProps: { innerHTML: _vm._s(faq.Title) }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "search-item-content",
                  domProps: { innerHTML: _vm._s(faq.Content) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "analyse-info" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("validCount")(faq.TotalViewCount)) +
                        "人浏览"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-10" }, [
                    _vm._v(
                      _vm._s(_vm._f("validCount")(faq.TotalCollectionCount)) +
                        "人收藏"
                    )
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          !_vm.AllFaqList.length
            ? _c("div", { staticClass: "noData" }, [_vm._v("暂无数据")])
            : _vm._e(),
          _vm._v(" "),
          _c("loading-more")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6c994587", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6c994587","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/faqList.vue
// module id = 4Vbu
// module chunks = 2